/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import * as icons from './components'

const FontAwesomeSVGLoader = () => {
  return (
    <>
      {Object.values(icons).map((IconComponent, idx) => (
        <IconComponent key={`FontAwesomeIcon-${idx}`} />
      ))}
    </>
  )
}

export default React.memo(FontAwesomeSVGLoader)
